import THead from 'components/UIKit/Table/THead';
import Tr from 'components/UIKit/Table/Tr';
import Th from 'components/UIKit/Table/Th';

type ErrorSummaryColumnsProps = {
  order: string,
  sort: string
}

export default function ErrorSummaryColumns({
  order,
  sort,
}: ErrorSummaryColumnsProps): React.Element {
  return (
    <THead>
      <Tr>
        <Th
          field="severity"
          order={order}
          sort={sort}
          sortable={!!sort}
          >
          Severity
        </Th>
        <Th
          field="count"
          order={order}
          sort={sort}
          sortable={!!sort}
          style={{ textAlign: 'right' }}
          >
          Count
        </Th>
        <Th>Description</Th>
      </Tr>
    </THead>
  );
}
